import Light from "./light";

const Theme = {
  ...Light,

  "--dark": "#323241",
  "--darker": "#252530",

  "--light-purple": "#826FB0",
  "--mid-purple": "#7058A9",

  "--primary-background-color": "var(--charcoal)",

  "--primary-font-color": "var(--light-gray)",
  "--title-font-color": "var(--light-gray)",

  "--alternating-bg-odd": "var(--dark)",
  "--alternating-bg-even": "var(--darker)",
};

export default Theme;
